import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PatientProcedureDaysDetailDTO } from '../../../../DTOs/PatientProcedures/Models/PatientProcedureDaysDetailDTO';
import { CommunicationType } from '../../../../core/enums/CommunicationType';
import { EmailSet } from '../../../../DTOs/Comms/Models/EmailSet';
import { TextRequestMessage } from '../../../../DTOs/Comms/Models/TextRequestMessage';
import { EmailRequestMessage } from '../../../../DTOs/Comms/Models/EmailRequestMessage';
import { BusChannelFeatures } from '../../../../core/GlobalConstants';
import { OrgSettingsService } from '../../../../org-settings/org-settings.service';
import { CommService } from '../../../../services/comm-service';
import { date } from '../../../../utils/date';
import { ChatMessageSenderType } from '../../../../core/enums/ChatMessageSenderType';
import { TranslateService } from '@ngx-translate/core';
import { CaseType } from '../../../../core/enums/org-settings/CaseType';
import { OrganisationDTO } from 'src/DTOs/Organisations/Models/OrganisationDTO';
import { PtvsDummyData } from 'src/core/PtvsDummyData';

export class dialogResult {
  "ID": string;
  "Message": string;
  "Created": Date;
  "UserName": string;
  "Sender": number;
}

@Component({
  selector: 'confirm-message-dialog',
  templateUrl: './confirm-message-dialog.html',
  styleUrls: ['./confirm-message-dialog.scss'],
})

export class ConfirmMessageDialog implements OnInit {
  public messageErr: string = '';
  public ShowErr: boolean = false;

  public ShowLoading: boolean = true;
  public ShowForm: boolean = false;
  public message: string = '';
  public procedure: string = '';
  public procedureName: string = "";
  public procedureDay: number;
  public procedureDayId: string = "";
  public actionCaseId: string = "";
  public centerName: string = "";
  public typeFormLink: string = "https://www.frc.ac/asdf1";
  public commType: number = 0;
  public commValue: string = "";
  public commValueName: string = "";
  public OrgId: string = "";
  public userID: string = "";
  public userName: string = "";

  public aftercareSettings: any = undefined;
  public emailSubjectTranslated: string = "Message from";
  public messageIntro: string = "To respond, click here:";
  public allowImages: boolean = false;
  public showImageToggle?: boolean = undefined;
  private googleReviewPTV = "{{GOOGLE_REVIEW_URL}}";


  constructor(
    private orgSettingService: OrgSettingsService,
    private commService: CommService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ConfirmMessageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.translate.get('confirm_message.email_subject').subscribe(res => {
      this.emailSubjectTranslated = res;
    });
    this.translate.get('confirm_message.message_intro').subscribe(res => {
      this.messageIntro = res;
    });
  }

  ngOnInit(): void {
    this.message = this.data.selectedText;
    this.procedureName = this.data.selectedProcedureName;
    this.procedureDay = this.data.selectedProcedureDay;
    this.procedureDayId = this.data.selectedProcedureDayId;
    this.actionCaseId = this.data.selectedActionLogId;
    this.centerName = this.data.selectedCenterName;
    this.commType = this.data.selectedCommType;
    this.commValue = this.data.selectedCommValue;
    this.commValueName = this.data.selectedCommValueName;
    this.OrgId = this.data.selectedOrgId;
    this.userID = this.data.selectedUserId;
    this.userName = this.data.selectedUserName;

    if (environment.debug_mode) {
      console.log("opening sendChatMessage...");
      console.log("procedureDayId: " + this.procedureDayId);
      console.log("actionCaseId: " + this.actionCaseId);
      console.log("CommType, 1.Email; 2.SMS: " + this.commType)
      console.log("CommValue: " + this.commValue)
      console.log("CommValueName: " + this.commValueName)
      console.log("UserID: " + this.userID);
      console.log("messageIntro:" + this.messageIntro);
    }

    this.setFeatureToggles();

    //--------------------------------------------
    // Load AftercareCases - begin
    //--------------------------------------------

    this.orgSettingService.getAftercareSettingsCases(this.OrgId, CaseType.Value("Case"))
      .subscribe(
        (response: any) => {

          this.aftercareSettings = response;

          if (typeof this.showImageToggle !== "undefined") {
            this.ShowForm = true;
            this.ShowLoading = false;
          }

        }

        ,
        error => {
          this.ShowForm = true;
          this.ShowLoading = false;
          this.ShowErr = true;
          console.error(error);
          this.messageErr = <string>error.message;
        });



      //--------------------------------------------
      // Load AftercareCases - end
      //--------------------------------------------

  }

  private setFeatureToggles() {
    this.orgSettingService.getOrganisation(this.OrgId).subscribe((org: OrganisationDTO) => {
      // if it's turned on, turn it off unless enabled. If it's off, leave it off either way.
      this.allowImages = this.allowImages && org.FeatureToggles.chatService_Enabled && org.FeatureToggles.chatService_AllowImages;

      // show the controls if the feature is enabled.
      this.showImageToggle = org.FeatureToggles.chatService_Enabled && org.FeatureToggles.chatService_AllowImages;
      if (typeof this.showImageToggle === "undefined") {
        this.showImageToggle = false; // set a value to unlatch the show/loading behaviour
      }
      if (typeof this.aftercareSettings !== "undefined") {
        this.ShowForm = true;
        this.ShowLoading = false;
      }
    }, error => {
      this.ShowForm = true;
      this.ShowLoading = false;
      this.ShowErr = true;
      console.error(error);
      this.messageErr = <string>error.message;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  onSaveClick(): void {

    this.messageErr = '';
    this.ShowErr = false;
    this.ShowLoading = true;
    this.ShowForm = false;


    if (this.commType == CommunicationType.Value('email')) {

      //-----------------------------------------------------
      // ------------- Send Email - begin -------------------
      //-----------------------------------------------------

      let emailRequest: EmailRequestMessage = new EmailRequestMessage();
      emailRequest.FeatureId = BusChannelFeatures.AftercareChatEmails;
      emailRequest.OrganizationId = this.OrgId;
      let tmpData: any =
      {
        "AppointmentEventId": this.procedureDayId,
        "SenderId": this.userID,
        "Sender": this.userName,
        "ActionCaseId": this.actionCaseId
      };
      emailRequest.Data = JSON.stringify(tmpData);
      emailRequest.IsImportant = true;
      emailRequest.IsPlainText = true;
      emailRequest.Subject = ""; //it is done in the API //this.emailSubjectTranslated + " " + this.centerName;
      emailRequest.Body = PtvsDummyData.ReplaceFromDummyData(this.message); ; //it is done on the API // + " " + this.messageIntro;
      emailRequest.ProviderTags = [];
      emailRequest.ProviderTags.push(BusChannelFeatures.ProviderTagRecalls);
      emailRequest.ProviderTags.push(BusChannelFeatures.ProviderTagAftercare);
      emailRequest.SendTo = [];
      var sendTo = new EmailSet();
      sendTo.Address = this.commValue;
      sendTo.DisplayName = this.commValueName;
      emailRequest.SendTo.push(sendTo);

      if (environment.debug_mode) {
        console.log("EmailRequestMessage: " + JSON.stringify(emailRequest));
      }

      this.commService.SendEmail(emailRequest, this.allowImages)
        .subscribe(
          (response: any) => {
            if (environment.debug_mode) {
              console.log("message sent, response: " + response);
            }

            this.onSaveClose(response);

          }
          ,
          error => {
            console.error(error);
          });

    }
    //-----------------------------------------------------
    // ------------- Send Email - end -------------------
    //-----------------------------------------------------

    if (this.commType == CommunicationType.Value('sms')) {

      //-----------------------------------------------------
      // ------------- Send SMS - begin -------------------
      //-----------------------------------------------------

      let textRequest: TextRequestMessage = new TextRequestMessage();
      textRequest.FeatureId = BusChannelFeatures.AftercareChatTexts;
      textRequest.OrganizationId = this.OrgId;
      let tmpData: any =
      {
        "AppointmentEventId": this.procedureDayId,
        "SenderId": this.userID,
        "Sender": this.userName,
        "ActionCaseId": this.actionCaseId
      };
      textRequest.Data = JSON.stringify(tmpData);
      textRequest.SendTo = this.commValue;
      textRequest.Body =  PtvsDummyData.ReplaceFromDummyData(this.message); //it is done on the API// + " " + this.messageIntro;

      if (environment.debug_mode) {
        console.log("TextRequestMessage: " + JSON.stringify(textRequest));
      }

      this.commService.SendTextMessage(textRequest, this.allowImages)
        .subscribe(
          (response: any) => {
            if (environment.debug_mode) {
              console.log("message sent, response: " + response);
            }
            this.onSaveClose(response);
          }
          ,
          error => {
            console.error(error);
          });

    }
    //-----------------------------------------------------
    // ------------- Send SMS - end -------------------
    //-----------------------------------------------------
  }

  onSaveClose(ID: string): void {

    let result: dialogResult = new dialogResult();
    result.ID = ID; //QueueID not the real ID;
    result.Created = date.getNowUtc();
    result.Message = this.message;
    result.Sender = ChatMessageSenderType.Value("Doctor");
    result.UserName = this.userName;

    //close windows
    this.dialogRef.close(result);


  }

  showFooter(): boolean {
    if (!this.message) return true;
    if (this.message.indexOf(this.googleReviewPTV) === -1) return true;
    return false;
  }


}
